<template>
    <form class="py-2 flex">
        <label for="name" class="hidden">{{ $t('Search') }}</label>
        <v-select
            :appendToBody="true"
            class="flex-1 style-select"
            @search="search"
            placeholder="Search user"
            :options="searchUserList"
            @input="setSelected"
            clearable
        >
            <template v-slot:option="option">
                <div
                    class="w-full py-3 flex items-center space-x-3 focus:outline-none overflow-x-hidden"
                >
                    <div
                        class="flex-shrink-0 w-12 sm:w-20 h-12 sm:h-20 rounded border-2 border-gray-200 overflow-hidden"
                    >
                        <img
                            loading="lazy"
                            alt="option.name"
                            width="100%"
                            height="100%"
                            class="object-cover"
                            :src="parseUrl(option.photoURL)"
                        />
                    </div>
                    <div class="flex-1 truncate">
                        <div class="flex items-center space-x-4">
                            <h3 class="text-sm sm:text-lg font-medium ml-2">
                                {{ option.name }}
                            </h3>
                            <span>{{ option.job }}</span>
                        </div>
                    </div>
                </div>
            </template>
        </v-select>
    </form>
</template>

<script>
import api from '../lib/api'
import _ from 'lodash'
export default {
    methods: {
        search: _.debounce(async function(search, loading) {
            if (!search || search === '') return
            loading(true)
            const result = await api.searchUsersByName(search)
            console.log('here')
            console.log(result)
            const makeList = list => {
                return list.map(item => {
                    return {
                        ...item,
                        label: item.name,
                        id: item.id,
                    }
                })
            }
            this.searchUserList = makeList(result)
            loading(false)
        }, 500),
        setSelected(value) {
            this.$router.push(`/users/${value.id}`)
        },
        parseUrl(url) {
            if (!url) return url
            if (url.startsWith('http')) {
                return url
            }
            return `https://cdn.giv.link/${url}`
        },
    },
    data() {
        return {
            searchUserList: [],
        }
    },
}
</script>
